// removed by extract-text-webpack-plugin
module.exports = {"preview":"_2S6OfCPPq5ycyBAsjA24gQ","card-title":"_3MxHfUjkwJaZFyJp2VbhuG","card-answer":"_3QaT1TD_v0JSz62xoCQ6Qe","preview-pane":"_2938UliwFVUkvY0OZ6EQLp"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/CardPreview.styl
// module id = 558
// module chunks = 0